import React, { useEffect,useRef, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { getTaskById, Tasking, updateTask } from "../../../core/api/useTask";
import { API_BASE_PATH } from "../../../environment";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import CommonSelect from "../../../core/common/commonSelect";
import CommonTagsInput from "../../../core/common/Taginput";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Loader from "../../../core/common/loader";
import { useAuthToken } from "../../../core/data/redux/useAuthToken";

const TaskDetails = () => {
  const location = useLocation();
  const { taskId } = location.state || {};

  const [taskDetails, setTaskDetails] = useState<Tasking | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [tags, setTags] = useState<string[]>([]);
  const fileRef = useRef<HTMLInputElement | null>(null);
    const empToken = useAuthToken();
  

  const statusChoose = [
    { value: "Inprogress", label: "Inprogress" },
    { value: "Completed", label: "Completed" },
    { value: "Pending", label: "Pending" },
    { value: "Onhold", label: "Onhold" },
  ];

  const priorityChoose = [
    { value: "Critical", label: "Critical" },
    { value: "High", label: "High" },
    { value: "Medium", label: "Medium" },
    { value: "Low", label: "Low" },
  ];

  const handleTaskUpdate = async (values: any) => {
    const formData = new FormData();
    Object.entries(values).forEach(([key, val]) => {
      formData.append(key, val as string);
    });

    formData.append("tags", tags.join(","));

    const file = fileRef.current?.files?.[0];
    if (file) {
      formData.append("upload_file", file);
    }

    try {
      await updateTask(empToken,taskId, formData);
      toast.success("✅ Task updated successfully!");
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  useEffect(() => {
    const fetchTask = async () => {
      try {
        const data = await getTaskById(empToken,taskId);
        setTaskDetails(data);
      } catch (error) {
        console.error("Error fetching task:", error);
      } finally {
        setLoading(false);
      }
    };

    if (taskId) fetchTask();
  }, [taskId]);

  if (loading) {
    return (
      <div className="page-wrapper">
        <div className="content text-center py-5">
          <Loader />            
        </div>
      </div>
    );
  }

  if (!taskDetails) {
    return (
      <div className="page-wrapper">
        <div className="content text-center py-5 text-danger">
          <h4>Task not found</h4>
        </div>
      </div>
    );
  }
  const getModalContainer = () => {
    return document.getElementById("modal-datepicker") || document.body;
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="row align-items-center mb-4">
            <div className="d-md-flex d-sm-block justify-content-between align-items-center flex-wrap">
              <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
                <Link to={all_routes.tasks}>
                  <i className="ti ti-arrow-left me-2" />
                  Back to List
                </Link>
              </h6>
              <div className="d-flex">
                <div className="text-end">
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_task"
                  >
                    <i className="ti ti-edit me-1" />
                    Edit Task
                  </Link>
                </div>
                <div className="head-icons ms-2 text-end">
                  <CollapseHeader />
                </div>
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          <div className="row">
            <div className="col-xl-8">
              <div className="card">
                <div className="card-body pb-1">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4">
                    <div>
                      <h4 className="mb-1">{taskDetails.taskName}</h4>
                      <p>
                        Priority :
                        <span className="badge badge-danger">
                          <i className="ti ti-point-filled me-1" />
                          {taskDetails.priority}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div className="row align-items-center">
                    {/* Description */}
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <h6 className="mb-1">Description</h6>
                        <p>
                          {taskDetails.description ||
                            "No description available"}
                        </p>
                      </div>
                    </div>

                    {/* Assignee */}
                    <div className="col-sm-3">
                      <p className="d-flex align-items-center mb-3">
                        <i className="ti ti-user-shield me-2" />
                        Assignee
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <div className="d-flex align-items-center mb-3">
                        <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                          <Link
                            to="#"
                            className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                          >
                            <img
                              src={`${API_BASE_PATH}/register/employee/${taskDetails.employee.employeeId}/image`}
                              alt="/assets/img/defaultavatar.png"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.onerror = null;
                                target.src = "/assets/img/defaultavatar.png";  
                               }}
                            />
                          </Link>
                          <h6 className="fs-12">
                            {taskDetails.employee.username}
                          </h6>
                        </div>
                      </div>
                    </div>

                    {/* Tags */}
                    <div className="col-sm-3">
                      <p className="d-flex align-items-center mb-3">
                        <i className="ti ti-bookmark me-2" />
                        Tags
                      </p>
                    </div>
                    <div className="col-sm-9">
                      <div className="d-flex align-items-center mb-3 flex-wrap gap-2">
                        {taskDetails.tags.length > 0 ? (
                          taskDetails.tags.map((tag) => (
                            <span
                              key={tag}
                              className="badge task-tag bg-info text-white rounded-pill"
                            >
                              {tag}
                            </span>
                          ))
                        ) : (
                          <span className="text-muted">No tags</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Files Section */}
              <div className="custom-accordion-items">
                <div className="accordion accordions-items-seperate">
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingFour">
                      <div className="accordion-button">
                        <div className="d-flex align-items-center flex-fill">
                          <h5>Files</h5>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderFour"
                      className="accordion-collapse collapse show border-top"
                      aria-labelledby="headingFour"
                    >
                      <div className="accordion-body">
                        {taskDetails.uploadFile ? (
                          <div className="card shadow-none mb-0">
                            <div className="card-body d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center">
                                <Link
                                  to={`${API_BASE_PATH}/Task/${taskDetails.uploadFile}`}
                                  target="_blank"
                                  className="avatar avatar-md bg-light me-2"
                                >
                                  <ImageWithBasePath
                                    src="assets/img/icons/file-02.svg"
                                    className="w-auto h-auto"
                                    alt="file"
                                  />
                                </Link>
                                <div>
                                  <h6 className="mb-1 text-truncate">
                                    {taskDetails.uploadFile}
                                  </h6>
                                  <span>Uploaded</span>
                                </div>
                              </div>
                              <div>
                                <a
                                 // href={`${API_BASE_PATH}/Task/${taskDetails.uploadFile}`}
                                  download
                                  className="btn btn-sm btn-icon"
                                >
                                  <i className="ti ti-download" />
                                </a>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <p className="text-muted">No files uploaded.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Panel */}
            <div className="col-xl-4">
              <div className="card">
                <div className="card-body p-0">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                      <p className="mb-0">Project</p>
                      <h6 className="fw-normal">
                        {taskDetails.project.projectName}
                      </h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                      <p className="mb-0">Started on</p>
                      <h6 className="fw-normal">{taskDetails.startDate}</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                      <p className="mb-0">Due Date</p>
                      <h6 className="fw-normal">{taskDetails.dueDate}</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                      <p className="mb-0">Estimated Hours</p>
                      <h6 className="fw-normal">
                        {taskDetails.estimatedHours || 0} hrs
                      </h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between p-3">
                      <p className="mb-0">Status</p>
                      <h6 className="fw-normal">{taskDetails.status}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Edit Modal */}
        <div className="modal fade" id="edit_task">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <Formik
                initialValues={{
                  task_name: taskDetails.taskName || "",
                  priority: taskDetails.priority || "",
                  status: taskDetails.status || "",
                  descriptions: taskDetails.description || "",
                  due_date: taskDetails.dueDate || "",
                  start_date: taskDetails.startDate || "",
                  end_date: taskDetails.endDate || "",
                  Assign_to: taskDetails.assignTo || "",
                  estimated_hours: taskDetails.estimatedHours?.toString() || "",
                  view: taskDetails.view?.toString() || "1",
                }}
                validationSchema={Yup.object({
                  task_name: Yup.string().required("Task name is required"),
                  priority: Yup.string().required("Priority is required"),
                  status: Yup.string().required("Status is required"),
                })}
                onSubmit={handleTaskUpdate}
              >
                {({ setFieldValue, values }) => (
                  <Form>
                    <div className="modal-header">
                      <h4 className="modal-title">Edit Task</h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="mb-3">
                        <label>Title</label>
                        <Field name="task_name" className="form-control" />
                      </div>

                      <div className="mb-3">
                        <label>Due Date</label>
                        <DatePicker
                          className="form-control w-100"
                          format="YYYY-MM-DD"
                          value={
                            values.due_date ? dayjs(values.due_date) : null
                          }
                          onChange={(date, dateString) =>
                            setFieldValue("due_date", dateString)
                          }
                          getPopupContainer={getModalContainer}
                        />
                      </div>

                      <div className="mb-3">
                        <label>Priority</label>
                        <CommonSelect
                          options={priorityChoose}
                          defaultValue={{
                            label: taskDetails.priority,
                            value: taskDetails.priority,
                          }}
                          onChange={(opt: any) =>
                            setFieldValue("priority", opt.value)
                          }
                        />
                      </div>

                      <div className="mb-3">
                        <label>Status</label>
                        <CommonSelect
                          options={statusChoose}
                          defaultValue={{
                            label: taskDetails.status,
                            value: taskDetails.status,
                          }}
                          onChange={(opt: any) =>
                            setFieldValue("status", opt.value)
                          }
                        />
                      </div>

                      <div className="mb-3">
                        <label>Description</label>
                        <Field
                          as="textarea"
                          name="descriptions"
                          className="form-control"
                          rows={3}
                        />
                      </div>

                      <div className="mb-3">
                        <label>Tags</label>
                        <CommonTagsInput value={tags} onChange={setTags} />
                      </div>

                      <div className="mb-3">
                        <label>Upload File</label>
                        <input
                          type="file"
                          ref={fileRef}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025 © IATT.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              IATT
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default TaskDetails;
